/* Free brochure packs in the cart: add / remove, then refresh the cart UI.
   Uses event delegation so it keeps working after the cart re-renders. */
(function () {
  if (window.__cartBrochuresInit) return;
  window.__cartBrochuresInit = true;

  // Re-render with the theme's own cart components (drawer and/or cart page).
  function refreshCart() {
    var targets = document.querySelectorAll('cart-drawer-items, cart-items');
    var done = false;
    targets.forEach(function (el) {
      if (typeof el.onCartUpdate === 'function') { el.onCartUpdate(); done = true; }
    });
    if (!done) window.location.reload();
  }

  function track(name, params) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) {}
  }

  function setBusy(button, busy) {
    button.disabled = busy;
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  document.addEventListener('click', function (event) {
    var addBtn = event.target.closest('[data-brochure-add]');
    var removeBtn = event.target.closest('[data-brochure-remove]');
    if (!addBtn && !removeBtn) return;
    event.preventDefault();

    var button = addBtn || removeBtn;
    setBusy(button, true);

    var request;

    if (addBtn) {
      request = fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(addBtn.dataset.brochureAdd), quantity: 1, properties: { _offer: 'brochure' } }]
        })
      });
    } else {
      request = fetch((window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: removeBtn.dataset.brochureRemove,
          quantity: 0
        })
      });
    }

    request
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state && state.status && state.status >= 400) throw new Error(state.description || 'Cart error');
        if (addBtn) track('brochure_add', { variant_id: addBtn.dataset.brochureAdd });
        refreshCart();
      })
      .catch(function () {
        setBusy(button, false);
        window.location.reload();
      });
  });
})();
